// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"d5a33427","412":"80679b84","970":"60472278"}[chunkId] + ".chunk.css";
};